import type { Scenario, Subscription } from "@/domain/entities";
import { useApp } from "../container";
import { useQuery } from "./useQuery";
import { useSettings } from "./useSettings";

export interface ActiveSubscription {
  subscriptions: Subscription[];
  scenarios: Scenario[];
  /** The remembered subscription when it still exists, otherwise the first one. */
  selected: Subscription | undefined;
  select: (subscriptionId: string) => Promise<void>;
  loading: boolean;
}

/** The scenario the Calendar and Reports tabs are looking at, remembered in settings. */
export function useActiveSubscription(): ActiveSubscription {
  const app = useApp();
  const settings = useSettings();
  const data = useQuery(async () => {
    const [subscriptions, scenarios] = await Promise.all([app.store.subscriptions.listAll(), app.store.scenarios.list()]);
    return { subscriptions, scenarios };
  }, [], app.changeSources);
  const subscriptions = data.data?.subscriptions ?? [];
  const remembered = settings.data?.activeSubscriptionId;
  const selected = subscriptions.find((s) => s.id === remembered) ?? subscriptions[0];
  return {
    subscriptions,
    scenarios: data.data?.scenarios ?? [],
    selected,
    select: async (subscriptionId) => {
      await app.store.settings.update({ activeSubscriptionId: subscriptionId });
    },
    loading: data.loading || settings.loading,
  };
}
